import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/percentage-change-calculator',
  component: () => import('../../routes/PercentageChangeCalculator.svelte'),
  card: {
    id: 'percentage-change-calculator',
    title: 'Percentage Change Calculator',
    description: 'Calculate the percentage change between two values. Find percent increase or decrease quickly and easily.',
    icon: 'percent',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/percentage-change-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Percentage Change Calculator – Find Percent Increase or Decrease',
    description: 'Free percentage change calculator to find the percent increase or decrease between two values. Calculate percentage change instantly with our easy-to-use tool.',
  },
};

export default meta;
